export const environment = {
  production: false,
  dialog: true
};

import 'zone.js/plugins/zone-error';

// qoxDP+6GnaPmTXF2e9yTclkRoto=
